import { render, staticRenderFns } from "./VerifyEmailByLink.vue?vue&type=template&id=47e7ad37&"
import script from "./VerifyEmailByLink.vue?vue&type=script&lang=ts&"
export * from "./VerifyEmailByLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports